import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/niemit.png'


const _withScopeId = n => (_pushScopeId("data-v-da4634de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_2 = {
  class: "float_login",
  style: {"border-radius":"10px","padding":"10px","background-color":"#333333","opacity":"0.85"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","color":"white"} }, "Username", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","color":"white"} }, "Password", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"color":"white","margin-left":"10px"} }, "Show Password", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","color":"white"} }, "Email", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "float-logo" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", { class: "content" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "height_logo_niemit"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: _normalizeStyle(_ctx.backgroundStyle),
          class: "center"
        }, null, 4),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                (!_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              class: "custom",
                              fill: "outline",
                              autofocus: true,
                              modelValue: _ctx.model.username,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.username) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              class: "custom",
                              fill: "outline",
                              type: _ctx.passwordFieldType,
                              modelValue: _ctx.model.password,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event))
                            }, null, 8, ["type", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_checkbox, {
                              modelValue: _ctx.showPassword,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPassword) = $event)),
                              onClick: _ctx.togglePasswordVisibility
                            }, null, 8, ["modelValue", "onClick"]),
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              color: "danger",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showResetPassword = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Non ricordo")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, { size: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              color: "success",
                              onClick: _ctx.Login_click
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Log in")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { style: {"text-align":"center"} }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.appStore.$LOGIN_LOGO_IMAGE,
                              class: "logo_nallebio"
                            }, null, 8, _hoisted_6)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              class: "custom",
                              fill: "outline",
                              type: "email",
                              modelValue: _ctx.resetEmail,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.resetEmail) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showResetPassword)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              color: "danger",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showResetPassword = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Annulla/Back")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, { size: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              color: "success",
                              onClick: _ctx.ResetPassword_click
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Recupera/Retrieve")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_ion_alert, {
          "is-open": _ctx.isOpenRef,
          header: "Attenzione",
          "sub-header": "Errore",
          message: _ctx.AlertMessage,
          buttons: ['OK'],
          onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ShowAlert(false)))
        }, null, 8, ["is-open", "message"])
      ]),
      _: 1
    }),
    _hoisted_8
  ], 64))
}